import axios from 'axios';

export default{
    //Create
    createNew: (barcode, bezeichnung, ablageOrt) => axios.post('objektapi/createObjekt', {barcode:barcode, bezeichnung:bezeichnung, ablageOrt:ablageOrt}),
    updateObjekt: (barcode, bezeichnung, ablageOrt) => axios.put('objektapi/updateObjekt/' + barcode, {barcode:barcode, bezeichnung:bezeichnung, ablageOrt:ablageOrt})
}